import { api } from './baseApi';

type Data = {
  merchantCode: string;
  currency: string;
  co2Quantity: number;
  activityType: string;
  paymentProvider: string;
  basketCountry: string;
};
export type Quote = {
  offsetPrice: { value: string; currency: string; zeroDecimalCurrency: boolean };
  carbonOffsetQuantity: { value: string; unit: string };
  quoteId: string;
  activityType: string;
};
const getQuoteByCO2Api = (data: Data, locale: string): Promise<Quote> =>
  api.post(`/quotes/v1/co2?locale=${locale}`, data);

export { getQuoteByCO2Api };
